type WeightedQuestion = { id: string; weight: number };

/** Preserve question order and metadata; allocate remaining whole percentages in order. */
export function equalSurveyWeights<T extends WeightedQuestion>(questions: readonly T[]): T[] {
  if (!questions.length) return [];
  const share = Math.floor(100 / questions.length), remainder = 100 % questions.length;
  return questions.map((question, index) => ({ ...question, weight: share + (index < remainder ? 1 : 0) }));
}

export function surveyWeightBps(questions: readonly WeightedQuestion[]): number {
  return questions.reduce((sum, q) => sum + (Number.isFinite(q.weight) ? Math.max(0, Math.round(q.weight * 100)) : 0), 0);
}

export function availableSurveyWeight(questions: readonly WeightedQuestion[], id: string): number {
  return Math.max(0, 10000 - surveyWeightBps(questions.filter(q => q.id !== id))) / 100;
}

export function exceedsSurveyWeight(questions: readonly WeightedQuestion[], id: string, value: number): boolean {
  return value * 100 > availableSurveyWeight(questions, id) * 100 + 1e-7;
}
